window.$ = window.jQuery = require('jquery-validation');
require('jquery-validation/dist/additional-methods.min');
require('./custom-validation');
require('./ajax-setup');
require('./country-region');
require('./industry-segment');
require('./register-form-init');
require('./registration-questions');
require('./facility-roles');
window.bsCustomFileInput = require('bs-custom-file-input');
